export const AUDIT_NODES = [
  { key: 'secondReview', auditor: 'defaultAuditorSecondReview', label: '二审' },
  { key: 'thirdReview', auditor: 'defaultAuditorThirdReview', label: '三审' },
  { key: 'seal', auditor: 'defaultAuditorSeal', label: '签章' },
] as const;

export const auditHeaders = Object.fromEntries(
  AUDIT_NODES.flatMap((n) => [
    [n.key + 'MinMinutes', n.label + '最小等待分钟数（清空/留空不修改）'],
    [n.key + 'MaxRandomMinutes', n.label + '最大随机分钟数（清空/留空不修改）'],
    [n.auditor, n.label + '默认审批人ID（清空/留空不修改）'],
  ]),
);

export function parseAuditFields(row: Record<string, unknown>) {
  const result: Record<string, unknown> = {};
  for (const n of AUDIT_NODES) {
    const min = String(row[auditHeaders[n.key + 'MinMinutes']] ?? '').trim();
    const max = String(
      row[auditHeaders[n.key + 'MaxRandomMinutes']] ?? '',
    ).trim();
    if (min || max) {
      result[n.key + 'TimeSpecified'] = true;
      if (min === '清空' && max === '清空') {
        result[n.key + 'MinMinutes'] = null;
        result[n.key + 'MaxRandomMinutes'] = null;
      } else {
        if (
          !/^\d+$/.test(min) ||
          !/^\d+$/.test(max) ||
          Number(min) > 2147483647 ||
          Number(max) > 2147483647 ||
          Number(max) < 1
        ) {
          throw new Error(
            n.label +
              '时间必须成对填写整数（最小≥0、随机≥1），或同时填写“清空”',
          );
        }
        result[n.key + 'MinMinutes'] = Number(min);
        result[n.key + 'MaxRandomMinutes'] = Number(max);
      }
    }
    const rawAuditor = row[auditHeaders[n.auditor]];
    if (typeof rawAuditor === 'number' && !Number.isSafeInteger(rawAuditor))
      throw new Error(
        n.label + '审批人ID超出Excel安全数字范围，请使用文本格式',
      );
    const auditor = String(rawAuditor ?? '').trim();
    if (auditor) {
      if (
        auditor !== '清空' &&
        (!/^[1-9]\d*$/.test(auditor) || BigInt(auditor) > 9223372036854775807n)
      )
        throw new Error(
          n.label + '审批人ID必须为有效正整数，请将Excel单元格设置为文本',
        );
      result[n.auditor + 'Specified'] = true;
      result[n.auditor] = auditor === '清空' ? null : auditor;
    }
  }
  return result;
}

export function uniformAuditFields(values: Record<string, any>) {
  const result: Record<string, unknown> = {};
  for (const n of AUDIT_NODES) {
    const mode = values[n.key + 'TimeMode'];
    if (mode === 'set' || mode === 'clear') {
      result[n.key + 'TimeSpecified'] = true;
      result[n.key + 'MinMinutes'] =
        mode === 'clear' ? null : values[n.key + 'MinMinutes'];
      result[n.key + 'MaxRandomMinutes'] =
        mode === 'clear' ? null : values[n.key + 'MaxRandomMinutes'];
    }
    const auditorMode = values[n.auditor + 'Mode'];
    if (auditorMode === 'set' || auditorMode === 'clear') {
      result[n.auditor + 'Specified'] = true;
      result[n.auditor] = auditorMode === 'clear' ? null : values[n.auditor];
    }
  }
  return result;
}
